import { render, staticRenderFns } from "./AllergySelect.vue?vue&type=template&id=49cf53d8&scoped=true&"
import script from "./AllergySelect.vue?vue&type=script&lang=js&"
export * from "./AllergySelect.vue?vue&type=script&lang=js&"
import style0 from "./AllergySelect.vue?vue&type=style&index=0&id=49cf53d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf53d8",
  null
  
)

export default component.exports